import type { DrugPathwayOptions } from '../configuration/shared';
import type { FillPathway } from '../contexts/fill';

export const shouldShowEscapeHatch = ({
    options,
    pathway,
    subPathway,
}: {
    options: DrugPathwayOptions | undefined;
    pathway: FillPathway | null;
    subPathway?: string | null;
}): boolean => {
    if (!options) {
        return false;
    }

    const { showEscapeHatch } = options;

    if (typeof showEscapeHatch === 'undefined' || showEscapeHatch === false) {
        return false;
    }

    if (showEscapeHatch === true) {
        return true;
    }

    if (!pathway) {
        return false;
    }

    if (typeof showEscapeHatch[pathway] === 'boolean') {
        return showEscapeHatch[pathway];
    }

    if (!!subPathway && typeof showEscapeHatch[pathway] === 'object') {
        return showEscapeHatch[pathway][subPathway];
    }

    return false;
};
